module.exports = __webpack_public_path__ + "static/media/Climeaction.d489fee9.png";